import { FC, useState, useContext, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import clsx from "clsx";
import {
  Button,
  AppBar,
  Toolbar,
  Container,
  Box,
  Typography,
  useMediaQuery,
  Drawer,
  Chip,
  Avatar,
  IconButton,
} from "@material-ui/core";
import { AdminHeaderProps } from "../../interfaces";
import { useTheme } from "@material-ui/core/styles";
import logo from "../../assets/images/HeaderLogoDark.svg";
import mobileLogo from "../../assets/images/HeaderLogoMobile.svg";
import TutorialsIcon from "../../assets/images/HeaderTutorialsIcon.svg";
import TicketsIcon from "../../assets/images/HeaderTicketsIcon.svg";
import { HeaderStyle } from "../Styles/LandingStyles";
import metamask from "../../assets/images/metamaskIcon.svg";
import ProjectPopover from "../Popover/ProjectPopover";
import ProfilePopover from "../Popover/ProfilePopover";
import WalletContext from "../../store/Wallet/WalletContext";
import AuthContext from "../../store/Auth/AuthContext";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import { formatDecimalNumber, shorter } from "../../utils/web3/formatBalance";
import { useEagerConnect } from "../../services/web3/hooks";
import { useAccount } from "wagmi";
import { useWalletConnect, useWeb3 } from "../../services/web3/hooks/useWeb3";
import TutorialsPopover from "../Popover/TutorialsPopover";

const AdminHeader: FC<AdminHeaderProps> = ({
  popoverRef,
  ticketsPopRef,
  gainsPopRef,
  restartTooltip,
  tutorialPop,
}) => {
  useEagerConnect();
  const [state, setState] = useState(false);
  const { amount, getUserWallets, currency, handleAccountChange } =
    useContext<any>(WalletContext);
  const { totalTickets, getUserSubscriptions } =
    useContext<any>(SubscriptionContext);
  const supportRef = useRef<any>(null);

  const { getProfileData, getProfile, isAuth } = useContext<any>(AuthContext);
  const projectPopover = useRef<any>(null);
  const ticketsRef = useRef<any>(null);
  const gainsRef = useRef<any>(null);
  const { address: account, chain } = useAccount();

  const { balance } = useWeb3();
  const { openConnectModal } = useWalletConnect();
  const {pathname} = useLocation();

  useEffect(() => {
    tutorialPop && tutorialPop(supportRef);
  }, [])

  useEffect(() => {
    if (account && chain) {
      ticketsPopRef && ticketsPopRef(ticketsRef);
      gainsPopRef && gainsPopRef(gainsRef);
      handleAccountChange(account, chain)
    }
    popoverRef && popoverRef(projectPopover);
  }, [account, chain]);

  useEffect(() => {
    if (isAuth) getProfile();
  }, [isAuth])

  const handleWalletConnect = (event: any) => {
    event.preventDefault();
    if (openConnectModal) openConnectModal();
  };

  const toggleDrawer = (open: boolean) => () => {
    setState(open);
  };

  const classes = HeaderStyle();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("xs"));
  const [popover, setPopover] = useState(false);
  const [popoverProfile, setPopoverProfile] = useState(false);
  const [, setPopoverNotication] = useState(false);
  const [tutorialsPopover, setTutorialsPopover] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : "";

  window.addEventListener("scroll", function () {
    popover && setPopover(false);
    popoverProfile && setPopoverProfile(false);
  });

  const handlePopover = (event: any) => {
    event.preventDefault();
    setPopover(true);
    setPopoverProfile(false);
    setPopoverNotication(false);
    setTutorialsPopover(false);  
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverProfile = (event: any) => {
    event.preventDefault();
    setPopover(false);
    setPopoverNotication(false);
    setPopoverProfile(true);
    setTutorialsPopover(false);   
    setAnchorEl(event.currentTarget);
  };

  const handleTutorialsPopover = (event: any) => {
    event.preventDefault();
    setPopover(false);
    setPopoverNotication(false);
    setPopoverProfile(false);
    setTutorialsPopover(true);
    setAnchorEl(event.currentTarget);
  };



  const MetaIcon = () => {
    return <img src={metamask} alt="" className="img-fluid img-icon" />;
  };
  return (
    <>
      <AppBar
        data-aos="fade-in"
        data-aos-duration="1200"
        className={classes.headerRoot}
        position="sticky"
        color="transparent"
      >
        <Container fixed>
          <Toolbar disableGutters={true}>
            {/* drawer icon on mobile  */}
           
            <Box component="div" className={classes.grow}>
              <NavLink to="/deals" style={{marginLeft:0}}>
                <img
                  ref={projectPopover}
                  src={isActive ? mobileLogo : logo}
                  alt="logo"
                  className={classes.logo}
                />
              </NavLink>
            </Box>
          
            { account ? (
              <>
                  <Box margin={isActive ? "0 .5rem" : "0 .75rem" }>
                    <Chip      
                    icon={<img src={TicketsIcon} alt="tickets" />}
                      label={
                        <Box display={"flex"}  alignItems="center">
                       
                          <Typography
                            component="span"
                            variant="subtitle1"
                            color="primary"
                            style={{margin:"0 0.25rem"}}
                          >
                            {totalTickets}
                          </Typography>{" "}
                          <Typography
                            ref={ticketsRef}
                           
                            color="secondary"
                            variant="subtitle1"
                            component="span"
                          >
                            {totalTickets > 1 ? "Tickets" : "Ticket"}
                          </Typography>
                        </Box>
                      }
                      variant="outlined"
                      className={classes.walletDetails}
                    />
                  </Box>      
                  <Box>
                    <Chip
                   
                    className={classes.walletDetails}
                      icon={<MetaIcon />}
                      label={
                        <>
                          <Typography
                            color="secondary"
                            variant="subtitle1"
                            component="span"
                          >
                            {shorter(account)}
                          </Typography>
                        </>
                      }
                      onClick={handlePopover}
                      variant="outlined"
                    />
                  </Box>
                

                {popover && (
                  <ProjectPopover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    setAnchorEl={setAnchorEl}
                    handleClose={handleClose}
                  />
                )}
              </>
            ) : (
              <>
                {!isActive ? (
                  <>
                  <NavLink to="./" style={{marginRight:0}}>
                    <Box>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={handleWalletConnect}
                        className={classes.connectWallet}
                        >
                        connect wallet
                      </Button>
                    </Box>
                  </NavLink>
                 
                  </>
                ):
                (pathname === "/deals" || pathname.includes("project-detail")) ?
                      <Box className={classes.floatConnectContainer}>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.floatConnectBtn}
                        onClick={handleWalletConnect}
                        
                        
                      >
                        connect wallet
                      </Button>
                      </Box>
                :null}
              </>
            )}
            {/*restartTooltip && (
              <Box
                fontSize={"22px"}
                color={"#b1b1b1"}
                mr={isActive && 2}
                mt={"3px"}
                onClick={restartTooltip}
                className="pointer"
              >
                <AiOutlineQuestionCircle />
              </Box>
            )*/}
            <Box marginX={"1rem"} className="pointer">
                <IconButton onClick={handleTutorialsPopover} color="primary">
                    <img src={TutorialsIcon} alt="tutorials" className={classes.supportIcon} ref={supportRef}/>
                  </IconButton>
                    {tutorialsPopover && (
                      <TutorialsPopover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                      />
                
            )}
            </Box>
            <Box component="div">
              <Avatar onClick={handlePopoverProfile} style={{width:"2.125rem", height:"2.125rem"}} className="pointer">
                {getProfileData?.username?.substr(0, 1)}
              </Avatar>
            </Box>

            {popoverProfile && (
              <ProfilePopover
                id={id}
                open={open}
                anchorEl={anchorEl}
                handleClose={handleClose}
              />
            )}
          </Toolbar>
        </Container>
      </AppBar>
      <Drawer
        classes={{
          paper: clsx(classes.drawerPaper, !state && classes.drawerPaperClose),
        }}
        anchor={"left"}
        open={state}
        onClose={toggleDrawer(false)}
      >
        <Box className="drawerwrapper border-bottom">
          <img src={logo} alt="logo" className="img-fluid" width="175" />
          <Box display="flex" alignItems="center" mt={3}>
            <Box mr="12px">
              {/* <img src={Profile} alt="Profile" className="pointer" /> */}
              <Avatar>{getProfileData?.username?.substr(0, 1)}</Avatar>
            </Box>
            <Typography variant="body1" color="primary" className="fw-bold">
              {getProfileData?.username}
              {"  "}
              {/* <Typography
                variant="body1"
                color="secondary"
                component="span"
                className="fw-bold"
              >
                Party
              </Typography> */}
            </Typography>
          </Box>
        </Box>
        {account ? (
          <>
           
            <Box px={4} pb={3}>
              <NavLink to="#" className="text-decoration-none">
                <Box >
                  <Chip
                  className={classes.walletDetails}
                    label={
                      <>
                        <Typography
                          component="span"
                          variant="subtitle1"
                          color="primary"
                          className="ml-8"
                        >
                          {totalTickets}
                        </Typography>{" "}
                        <Typography
                          color="secondary"
                          variant="subtitle1"
                          component="span"
                        >
                          Tickets
                        </Typography>
                      </>
                    }
                    variant="outlined"
                  />
                </Box>
              </NavLink>
            </Box>
            <Box px={4} pb={3} className="border-bottom">
              <NavLink to="./" className="text-decoration-none">
                <Box >
                  <Chip
                  className={classes.walletDetails}
                    icon={<MetaIcon />}
                    label={
                      <>
                        <Typography
                          component="span"
                          variant="subtitle1"
                          color="primary"
                        >
                          {(balance && balance.formatted) ? formatDecimalNumber(balance.formatted) : ''}&nbsp;
                            {balance?.symbol}
                        </Typography>{" "}
                        <Typography
                          color="secondary"
                          variant="subtitle1"
                          component="span"
                        >
                          {account?.length > 5
                            ? account.substr(0, 8) +
                              "..." +
                              account.substr(account.length - 6, account.length)
                            : account}
                        </Typography>
                      </>
                    }
                    onClick={handlePopover}
                    variant="outlined"
                  />
                </Box>
              </NavLink>
              {popover && (
                <ProjectPopover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  handleClose={handleClose}
                  setAnchorEl={setAnchorEl}
                />
              )}
            </Box>
          </>
        ) : (
          <>
            <Box px={4} pb={3} className="border-bottom">
              <NavLink
                className="text-decoration-none"
                to="./"
                color="secondary"
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.fs}
                  onClick={handleWalletConnect}
                >
                  connect wallet
                </Button>
              </NavLink>
            </Box>
          </>
        )}

        <Box px={4} pb={3}>
        </Box>
      </Drawer>
    </>
  );
};

export default AdminHeader;
